import { useEffect } from "react";

const PageVisibilityHandler = () => {
	useEffect(() => {
		// Function to handle tab focus
		const handleFocus = () => {
			console.log("Tab is in focus");
			// Place your data refresh logic here
		};

		// Function to handle tab blur
		const handleBlur = () => {
			console.log("Tab is out of focus");
			// Place your logic for when the tab is not in focus
		};

		// Add event listeners for focus and blur events
		window.addEventListener("focus", handleFocus);
		window.addEventListener("blur", handleBlur);

		// Clean up event listeners on component unmount
		return () => {
			window.removeEventListener("focus", handleFocus);
			window.removeEventListener("blur", handleBlur);
		};
	}, []);

	return null; // This component doesn't render anything
};

export default PageVisibilityHandler;

export const hideDetails = ["/profile/", "/event/", "/icebreaker/"];
